import type { QuizPage } from './types'

export const quizPagesEn: QuizPage[] = [
  {
    id: 'intro',
    type: 'showcase',
    image: 'https://cdn-site.clarymind.com/clarymind-tools-cover.jpg',
    title: 'Find Your Focus Path',
    description: 'Take this short quiz to discover how Clarymind can help you regain control of your time and attention.',
    ctaText: 'Start Now',
  },
  {
    id: 'phone-usage',
    type: 'scale-rating',
    question: 'How many hours per day do you spend on your phone?',
    min: 1,
    max: 5,
    labels: { min: '1-2 hrs', max: '6+ hrs' },
  },
  {
    id: 'pain-points',
    type: 'multi-select',
    question: 'Which of these resonate with you?',
    options: [
      { value: 'scroll', label: 'Mindlessly scrolling when I meant to do something else' },
      { value: 'sleep', label: "Can't stop checking my phone before bed" },
      { value: 'focus', label: 'Struggling to focus on work or study' },
      { value: 'anxiety', label: 'Feeling anxious when away from my phone' },
    ],
    minSelect: 1,
  },
  {
    id: 'transition',
    type: 'transition',
    message: 'Calculating your results...',
    durationMs: 1500,
  },
  {
    id: 'results',
    type: 'showcase',
    image: 'https://cdn-site.clarymind.com/product-page-app/benefits/benefit-01.jpg',
    title: 'Clarymind is built for you',
    description: 'Based on your answers, Clarymind can help you break the scroll cycle and build lasting focus habits.',
    socialProof: { testimonials: true, ratings: true },
  },
]
